export enum ParameterRuleType {
    HIDE_IF = 'HIDE_IF',
    AUTO_SELECT_BY_COUNT = 'AUTO_SELECT_BY_COUNT',
    NONE_EXCLUSIVE = 'NONE_EXCLUSIVE',
    EXCLUDE_SELECTED = 'EXCLUDE_SELECTED',
    VALIDATE_TOTAL_COUNT = 'VALIDATE_TOTAL_COUNT',
    VALIDATE_MAX = 'VALIDATE_MAX',
    VALIDATE_MIN = 'VALIDATE_MIN'
}

export enum EquipmentType {
    SYSTEM = 'system',
    ZONE = 'zone'
}